import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { AlertTriangle } from "lucide-react";

const PRESETS = {
  403: { title: "Access Denied", message: "You don't have permission to view this page. If you believe this is a mistake, contact your administrator." },
  404: { title: "Page Not Found", message: "The page you're looking for doesn't exist or may have been moved." },
  500: { title: "Something Went Wrong", message: "An unexpected error occurred on our end. Please try again in a moment." },
};

export default function ErrorPage({ code = 404 }) {
  const navigate = useNavigate();
  const preset = PRESETS[code] || PRESETS[404];
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#0A0A0A] px-5 text-center text-white" data-testid={`error-page-${code}`}>
      <div className="mb-8 h-9"><Logo className="h-9" showText /></div>
      <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-[#E30613]/[0.12]">
        <AlertTriangle className="h-8 w-8 text-[#FF1C2A]" />
      </div>
      <p className="mt-8 font-display text-6xl font-semibold tracking-tight text-white">{code}</p>
      <h1 className="mt-3 font-display text-xl font-semibold text-white">{preset.title}</h1>
      <p className="mt-2 max-w-md text-sm text-neutral-500">{preset.message}</p>
      <div className="mt-8 flex gap-3">
        <button onClick={() => navigate(-1)} className="rounded-lg border border-white/[0.1] px-5 py-2.5 text-sm font-medium text-neutral-200 transition-colors hover:bg-white/[0.05]" data-testid="error-back-btn">Go Back</button>
        <button onClick={() => navigate("/dashboard")} className="rounded-lg bg-[#E30613] px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-[#FF1C2A]" data-testid="error-home-btn">Return Home</button>
      </div>
    </div>
  );
}
